import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import CommonTabs from "../../../common_components/CommonTabs";
const DateRangeTabs = ({ selectedRange, onChange, mode = "account", tabs, disabled = false, sx, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const defaultTabs = mode === "performance"
        ? [
            { label: "Daily", value: "day" },
            { label: "Week", value: "week" },
            { label: "Month", value: "month" },
        ]
        : [
            { label: "Today", value: "today" },
            { label: "Yesterday", value: "yesterday" },
            { label: isMobile ? "L7D" : "Last 7 days", value: "last7days" },
            { label: isMobile ? "L30D" : "Last 30 days", value: "last30days" },
        ];
    const finalTabs = tabs ?? defaultTabs;
    return (_jsx(CommonTabs, { selectedValue: selectedRange, onChange: onChange, tabs: finalTabs, disabled: disabled, sx: sx }));
};
export default DateRangeTabs;
